import Relay from 'react-relay';

export default class SaveFlowInvocationAsTestMutation extends Relay.Mutation {
    getMutation() {
        return Relay.QL`mutation {saveFlowInvocationAsTest}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on SaveFlowInvocationAsTestPayload {
                testInvocation {
                    id,
                    name,
                    flowDef {
                        id
                    }
                }
                success
                error
                errors {
                    field
                    message
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            flowInvocationId: this.props.flowInvocationId,
            name: this.props.name,
            bindToFlow: this.props.bindToFlow,
        };
    }
}
